export const ToolsIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9901 13.239L11.0536 14.1755L2 8.2439L8.24384 2.00006L14.1755 11.0536L13.2389 11.9902L23.0772 21.8285C24.7915 20.6928 27.1239 20.8801 28.6342 22.3904L34.8781 28.6343C36.6023 30.3585 36.6023 33.1539 34.8781 34.8781C33.1539 36.6023 30.3584 36.6023 28.6342 34.8781L22.3904 28.6343C20.8801 27.1239 20.6927 24.7915 21.8285 23.0773L11.9901 13.239Z"
				fill="url(#paint0_linear_169_228)"
			/>
			<path
				d="M36.5651 8.99711C36.5523 8.98434 33.9665 11.5423 28.8202 16.6837L25.2094 13.0702L32.9032 5.37089C28.8543 2.93213 23.6528 3.55778 20.2801 6.93289C18.9908 8.22231 18.0631 9.82829 17.5898 11.5898C17.1165 13.3512 17.5173 15.7202 17.9866 17.4827L18.0631 17.7679L5.93266 29.9C5.66897 30.1639 5.80123 30.4756 6.06492 30.7394L11.1445 35.8197C11.4082 36.0836 11.7342 36.2299 11.9979 35.966L24.1284 23.8339L24.4133 23.9105C27.9731 24.8597 32.295 24.2766 34.9489 21.6208C38.3259 18.2457 38.9511 13.0404 36.5651 8.99711Z"
				fill="#262A2F"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_169_228"
					x1="33.0971"
					y1="39.9653"
					x2="0.0346947"
					y2="6.90297"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#5C90FC" />
					<stop offset="1" stopColor="#B7D2FF" />
				</linearGradient>
			</defs>
		</svg>
	)
}
